"use client";

import { Suspense, useEffect } from "react";
import { notFound, useRouter, useSearchParams } from "next/navigation";
import LoadingSpinner from "@/components/LoadingSpinner";
import { toolsRegistry } from "@/contexts/ToolsContext";
import EditorV2Shell, { editorV2ConfigComponents } from "../_components/EditorV2Shell";
import {
  PHOTO_EDITOR_REGISTRY_TOOL_ID,
  buildPresetHref,
  getDefaultPresetTool,
} from "@/app/editor/data/ai-photo-editor";

function EditorV2Page({ params }: { params: { toolId: string } }) {
  const { toolId } = params;
  const router = useRouter();
  const searchParams = useSearchParams();
  const toolInfo = toolsRegistry.find((t) => t.id === toolId);
  const hasV2Component = !!editorV2ConfigComponents[toolId];

  useEffect(() => {
    if (toolId === PHOTO_EDITOR_REGISTRY_TOOL_ID) {
      const fromQuery = searchParams.get("preset");
      router.replace(buildPresetHref(fromQuery || getDefaultPresetTool().id));
      return;
    }
    if (!hasV2Component) {
      router.replace(`/editor/${toolId}`);
    }
  }, [router, toolId, hasV2Component, searchParams]);

  if (!toolInfo) {
    notFound();
  }

  if (toolId === PHOTO_EDITOR_REGISTRY_TOOL_ID || !hasV2Component) {
    return <LoadingSpinner fullScreen text="Opening editor..." />;
  }

  return <EditorV2Shell toolInfo={toolInfo} />;
}

export default function EditorV2PageRoute({ params }: { params: { toolId: string } }) {
  return (
    <Suspense fallback={<LoadingSpinner fullScreen text="Loading editor..." />}>
      <EditorV2Page params={params} />
    </Suspense>
  );
}
